import React from "react";
import "./PageBanner.css";
import { Link } from "react-router-dom";
import shape1 from "../../media/shapebanner1.png";
import shape2 from "../../media/shapebanner2.png";

const PageBanner = ({ title, breadcrumb, bgImage }) => {
  return (
    <section
      className="page-banner-wrapper d-flex align-items-center"
      style={{ "--banner-bg": `url(${bgImage})` }}
    >
      <div className="page-banner-overlay"></div>

      {/* Decorative shapes */}
      <div className="page-banner-shape page-banner-shape-1">
        <img src={shape1} alt="Decorative Shape 1" />
      </div>
      <div className="page-banner-shape page-banner-shape-2">
        <img src={shape2} alt="Decorative Shape 2" />
      </div>

      <div className="page-banner-container position-relative container">
        <div className="row w-100 align-items-center">
          <div className="col-md-6 text-white">
            <h1 className="page-banner-title">{title}</h1>
          </div>
          <div className="col-md-6 text-md-end mt-3 mt-md-0">
            <div className="page-banner-breadcrumb-box d-inline-block px-4 py-2 text-white">
              <Link to="/" className="text-white text-decoration-none">
                Aspen SR
              </Link>{" "}
              <span className="mx-2">›</span> {breadcrumb}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageBanner;
